export default {
  settings: {
    title: 'Settings',
    account_related: 'Account Information',
    user_related: 'User Information',
    add_user_title: 'Add User',
    edit_user_title: 'Edit User',
    label: {
      enabled: 'enabled',
      not_set: 'Not set',
    },
    company: {
      title: 'Company Information',
      name: 'Company name',
      english_name: 'English name',
      scale: 'Number of Employees',
      industry_type: 'Industry',
      plan: 'Plan',
      location: 'Address',
      allowed_ip: 'Allowed IP Addresses',
      mfa: 'SMS Authentication',
      sales_amount: 'Revenue',
      country: 'Country',
    },
    contract_plans: {
      buyer: 'Buyer Plan',
      supplier: 'Supplier Plan',
    },
    contents: {
      title: 'Contents',
      manual_with_brackets: 'Manual ({content})',
    },
    user: {
      title: 'User Information',
      name: 'Name',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email address',
      email_unverified: 'Before registration',
      password: 'Password',
      password_protection: 'Not shown for security reasons.',
      phone_number: 'Phone number',
      role: {
        title: 'Permission',
        admin: 'Admin',
        general: 'General',
      },
      locale: 'Select language',
      action: 'Operation',
      total: 'All: {total} (Max. {max})',
    },
    button: {
      create: 'Add User',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【Notice】',
    cautions_01: 'You cannot change your e-mail address. To reset your email, please create a new user.',
    cautions_02: 'A phone number is required if SMS authentication is activated.',
    cautions_03: 'To reset your password, please enter the verification code sent to your registered email address into the password reset screen.',
    cautions_04: 'Deleting a user does not delete the answer data or scorecard.',
    messages: {
      user_update: 'Update user information',
      user_delete: 'Delete user',
      confirm_delete: 'Do you want to delete this user?',
      complete_create: 'User information has been added.',
      complete_update: 'User information has been updated.',
      complete_delete: 'User information has been deleted.',
      disabled_delete: 'At least one user must be an "Admin" authority.',
      disabled_delete_by_auth: 'Only Admin can delete.',
      invalid_form: 'Incorrect Input.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'After clicking "ADD", a confirmation email will be sent to the email address you entered.\n　Subsequently, an email containing your login ID and password will be sent.',
      caution_two: 'A phone number is required if SMS authentication is activated.',
      caution_three: 'Users can be added up to 5 users.',
      user_add_title: '@:settings.button.create',
      user_add_message_one: 'We have sent an email to the address you provided.',
      user_add_message_two: 'Please check your email and follow the instructions in the email to login.',
    },
    tips: {
      role: 'The "Admin" authority can add and delete users, but the "General" authority cannot.',
      locale: 'You can select the initial language setting after login.',
    },
    english_name_edit_modal_title: 'English name Settings',
    english_name_input_label: 'English name',
    english_name_placeholder: 'Enter English name',
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'Are you sure you want to log out and go to the password reset page? On the password reset page, please input the verification code provided in the email sent to your registered email address.',
      reset: 'Reset Password',
    },
  },
}
